import { Component, Input, OnChanges, signal, Type, ViewChild, viewChild, ElementRef, Output, EventEmitter, effect } from '@angular/core';
import { DialogModule } from 'primeng/dialog';
import { NgComponentOutlet } from '@angular/common';
import { StateComponent } from '../../states/state-component.interface';
import { Usdm2Service } from '../../../../services/ai/usdm2.service';
import { Subscription } from 'rxjs';
import { MarkdownComponent, provideMarkdown } from 'ngx-markdown';
import { PdfViewerComponent } from '../pdf-viewer/pdf-viewer.component';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-state-update-view',
  imports: [DialogModule, NgComponentOutlet, MarkdownComponent, PdfViewerComponent, FormsModule],
  providers: [provideMarkdown()],
  templateUrl: './state-update-view.component.html',
  styleUrl: './state-update-view.component.css',
})
export class StateUpdateViewComponent implements OnChanges {
  isVisible = false;
  @Input() state!: { name: string, component: Type<object> | null };
  @ViewChild(NgComponentOutlet, { static: false }) outlet!: NgComponentOutlet;
  @Output() reRun = new EventEmitter<{ stateName: string, userMsg: string | null }>();
  instance: StateComponent | null = null;

  stateUpdatesStream = signal<string|null>(null);
  streamSubscription: Subscription | null = null;
  messageContainer = viewChild<ElementRef>('messageContainer');
  // private messagesDiv: HTMLElement | null = null;

  reRunMessage: string | null = null;
  spinning: boolean = false;
  
  constructor(private usdm: Usdm2Service) {
    effect(() => {
      if (!this.usdm.isRunningState()) {
        this.spinning = false;
      }
    });
  }


  ngOnChanges() {
    queueMicrotask(() => {
      this.instance = this.outlet?.componentInstance;
    });
  }

  get data() {
    return this.usdm.states[this.state.name]?.data || null;
  }

  get isRunningState() {
    return this.usdm.isRunningState();
  }

  toggleDialog() {
    this.isVisible = !this.isVisible;
    if (this.isVisible) {
      this.streamSubscription?.unsubscribe();
      this.streamSubscription = this.usdm.currentStateUpdatesStream$.subscribe(update => {
        this.stateUpdatesStream.set(update);
        setTimeout(() => this.scrollToBottom(), 0);
      });
    } else if (this.streamSubscription) {
      this.streamSubscription.unsubscribe();
      this.streamSubscription = null;
    }
  }

  stringifyData(data: object | null): string {
    const jsonString = JSON.stringify(data, null, 2);
    return jsonString;
  }

  formatToolCall(key: string, value: unknown): string {
    if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
      return `<div class="flex flex-col gap-1 py-1 text-gray-300">
        <span class="text-black font-2xl font-bold">${key}:</span>
        <div class="ml-4 pl-2">
          ${Object.entries(value)
          .map(([subKey, subValue]) => this.formatToolCall(subKey, subValue))
          .join('')}
        </div>
      </div>`;
    } else {
      return `<div class="flex gap-2 py-1 text-gray-300">
      <span class="text-black font-2xl font-bold">${key}:</span>
      <span class="text-gray-800 font-mono break-all whitespace-pre-line max-w-full">${value}</span>
    </div>`;
    }
  }

  formatExtractedData(data: object | null): string {
    if (!data) return '';
    return Object.entries(data)
      .map(([key, value]) => this.formatToolCall(key, value))
      .join('');
  }

  scrollToBottom() {
    const container = this.messageContainer();
    if (container && container.nativeElement) {
      container.nativeElement.scrollTo({
        top: container.nativeElement.scrollHeight,
        behavior: 'smooth',
      });
    }
  }

  handleStop() {
    this.spinning = true;
    this.usdm.aiWriting.set(false);
  }

  reRunState() {
    this.reRun.emit({ stateName: this.state.name, userMsg: this.reRunMessage });
  }
}
